module.exports = __webpack_public_path__ + "img/map_restaurant.d733df94.png";